import React from 'react';

const ForbiddenError = () => {
    return (
        <div className="NoResult-Container">
            <div className="NoResult-First-Title-Secondary">No Results</div>
        </div>
    );
};

export default ForbiddenError;
